import UtilityService from "../services/UtillityServices/UtilityService";

const useContabilizzazioniConfigTable = () => {
    return [
      { key: "numero_fattura", label: "Numero fattura" },
      { 
        key: "data_fattura",
        label: "Data fattura",
        formatter: (value) => value ? UtilityService.formatDate(value) : "Nessuna" 
      },
      {
        key: "classi_utente.corso_denominazione",
        label: "Corso",
        hideOrder: true,
        formatter: (value, row) => `${row.classi_utente?.corso_denominazione}`
      },
      {
        key: "classi_utente.nome",
        label: "Corsista",
        hideOrder: true,
        formatter: (value, row) => `${row.classi_utente?.nome} ${row.classi_utente?.cognome}`
      },
      { key: "note", label: "Note", hideOrder: true },
      { key: "importo_totale", label: "Provvigione partner" },
    ];
  };
  
export default useContabilizzazioniConfigTable;
